import React from 'react';

interface RiskScoreProps {
  score: number;
  showLabel?: boolean;
}

export default function RiskScore({ score, showLabel = false }: RiskScoreProps) {
  const getColor = () => {
    if (score >= 75) return 'text-danger';
    if (score >= 50) return 'text-warning';
    if (score >= 25) return 'text-primary';
    return 'text-success';
  };

  const getBg = () => {
    if (score >= 75) return 'bg-danger/10 border-danger/20';
    if (score >= 50) return 'bg-warning/10 border-warning/20';
    if (score >= 25) return 'bg-primary/10 border-primary/20';
    return 'bg-success/10 border-success/20';
  };

  const getLabel = () => {
    if (score >= 75) return 'Critical';
    if (score >= 50) return 'High';
    if (score >= 25) return 'Medium';
    return 'Low';
  };

  return (
    <span data-component-id="src\components\ui\RiskScore.tsx:31:4" data-component-path="src\components\ui\RiskScore.tsx" data-component-line="31" data-component-end-line="36" data-component-file="RiskScore.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded border font-mono text-[11px] font-600 tabular-nums ${getBg()} ${getColor()}`}
    >
      {score}
      {showLabel && <span data-component-id="src\components\ui\RiskScore.tsx:35:20" data-component-path="src\components\ui\RiskScore.tsx" data-component-line="35" data-component-end-line="35" data-component-file="RiskScore.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-sans%20font-500%20text-%5B10px%5D%20opacity-75%22%7D" className="font-sans font-500 text-[10px] opacity-75">{getLabel()}</span>}
    </span>
  );
}
